import Layout from '../../Components/Templates/Layout';
import SpaceImage from '../../Assets/Images/nasa-space.jpg';
import { Center, Flex, Heading, Link, Text } from '@chakra-ui/react';

const Contact = () => {
    return (
        <Layout topBarMaxWidth={ 1400 }>
            <Flex flexDirection='column' flex='1'>
                <Flex flexDirection='row'>
                    <Flex 
                        flex='1' 
                        backgroundImage={ SpaceImage }
                        height='300px'
                        backgroundPosition='center'
                        backgroundSize='cover'
                    />
                </Flex>
                <Flex>
                    <Center display='flex' flex='1'>
                        <Flex 
                            flex='1' 
                            maxWidth='1400px' 
                            flexDirection='column'
                            padding='10px'
                        >
                            <Center>
                                <Heading 
                                    color='brand.orange'
                                    marginTop='20px'
                                    marginBottom='20px'
                                >
                                    CONTACT
                                </Heading>
                            </Center>
                            <Center>
                                <Center 
                                    display='flex'
                                    flex='1'
                                    margin='5px'
                                    flexDirection='column'
                                >
                                    <Heading size='sm' marginBottom='10px' textAlign='center'>
                                        GENERAL ENQUIRIES
                                    </Heading>
                                    <Text>
                                        <Link href='tel:+44 (0) 23 9259 6338'>+44 (0) 23 9259 6338</Link>
                                    </Text>
                                </Center>
                            </Center>
                            <br />
                            <Flex 
                                flex='1'
                                marginBottom='100px'
                            >
                                <Center 
                                    display='flex' 
                                    flex='1'
                                >
                                    <Flex 
                                        maxWidth='800px' 
                                        flex='1' 
                                        flexWrap='wrap'
                                    >
                                        <Center 
                                            display='flex'
                                            flex='1'
                                            margin='5px'
                                            flexDirection='column'
                                        >
                                            <Heading size='sm' marginBottom='10px' textAlign='center'>
                                                SALES
                                            </Heading>
                                            <Text>
                                                <Link href='mail:test@test.com'>sales@virtue-aerospace.com</Link>
                                            </Text>
                                        </Center>
                                        <Center 
                                            display='flex'
                                            flex='1'
                                            margin='5px'
                                            flexDirection='column'
                                        >
                                            <Heading size='sm' marginBottom='10px' textAlign='center'>
                                                ACCOUNTS
                                            </Heading>
                                            <Text>
                                                <Link href='mail:test@test.com'>accounts@virtue-aerospace.com</Link>
                                            </Text>
                                        </Center>
                                        <Center 
                                            display='flex'
                                            flex='1'
                                            margin='5px'
                                            flexDirection='column'
                                        >
                                            <Heading size='sm' marginBottom='10px' textAlign='center'>
                                                QUALITY
                                            </Heading>
                                            <Text>
                                                <Link href='mail:test@test.com'>quality@virtue-aerospace.com</Link>
                                            </Text>
                                        </Center>
                                    </Flex>
                                </Center>
                            </Flex>
                        </Flex>
                    </Center>
                </Flex>
            </Flex>
        </Layout>
    );
};

export default Contact;